var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelperMessage',{scopedSlots:_vm._u([{key:"message",fn:function(){return [_vm._v(" Guardia en curso ")]},proxy:true}])},[_c('IndicatorPulse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }